export const firebaseConfig = {
  "projectId": "studio-4377689393-ba0df",
  "appId": "1:163577370316:web:3cd59dbeb89f30d10a5469",
  "apiKey": "AIzaSyDlzsEp78MArf0fqLfz61pCz2F17TqurQ8",
  "authDomain": "studio-4377689393-ba0df.firebaseapp.com",
  "measurementId": "",
  "messagingSenderId": "163577370316"
};
